import { useState, useCallback } from 'react';
import { useMount } from 'react-use';
import { useMeStore } from '~/modules/SDK/me/useMeStore';
import { FrFirebase } from '~/modules/SDK/firebase/FrFirebase';
import { onSnapshot } from 'firebase/firestore';
/** 傳入 collection, document 名字，並且賦予型別，回傳 data */
export const useFirebaseValue = (collection, document) => {
    // const firestore = FrFirebase.firestore
    // const collectionRef = firestore().collection(collection)
    const { meUserState } = useMeStore();
    const userCode = meUserState?.uid || undefined;
    const [data, setData] = useState();
    const getValue = useCallback(() => {
        if (userCode) {
            onSnapshot(FrFirebase.getDocRef(collection, document), docRef => {
                setData(docRef.data());
            });
            // collectionRef.doc(document).onSnapshot(doc => setData(doc.data() as T))
        }
    }, [collection, document, userCode]);
    useMount(() => {
        getValue();
    });
    return data;
};
